import React from 'react';

import { Box, Button, Typography } from '@mui/material';

import { appRoutes } from '@clearverify/constants';

import { OOOPS } from 'src/assets';
import { useAppAuth } from 'src/hooks/auth';
import { SxProp } from 'src/types/mui';

export const ErrorBoundaryFallback: React.FC = () => {
  const { isAuthorized } = useAppAuth();

  const textInBtn = isAuthorized ? 'Home page' : 'Login page';

  const reloadPage = React.useCallback(() => {
    window.location.reload();
  }, []);

  const handleGoTo = React.useCallback(() => {
    const linkGoTo = isAuthorized ? appRoutes.root : appRoutes.auth.index;
    window.location.replace(linkGoTo);
  }, [isAuthorized]);

  return (
    <Box textAlign="center" p={5} sx={containerStyles}>
      <img style={imgStyles} alt="Ooops" src={OOOPS} />

      <Typography variant="h1" sx={titleStyles}>
        Something went wrong
      </Typography>

      <Box mt={2.5}>
        <Typography variant="body1" color="text.secondary">
          We’re sorry, but an unexpected error occurred.
        </Typography>

        <Typography variant="body1" color="text.secondary">
          Please try reloading the page or come back later.
        </Typography>
      </Box>

      <Box display="flex" mt={4} gap={4}>
        <Button size="large" variant="contained" onClick={reloadPage}>
          Reload page
        </Button>

        <Button size="large" variant="contained" onClick={handleGoTo}>
          Back to {textInBtn}
        </Button>
      </Box>
    </Box>
  );
};

const imgStyles: React.CSSProperties = {
  width: '100%',
  maxWidth: '847px',
  marginBottom: '44px',
};

const containerStyles: SxProp = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
};

const titleStyles: SxProp = theme => ({
  fontSize: '24px',

  [theme.breakpoints.up('md')]: {
    fontSize: '48px',
  },
});
